module.exports = {
  IS_CUSTOM: "c",
  MAP_ID: "cm",
  MODE_INDEX: "g",
  MAP_INDEX: "m",
  INFO: "i",
  VERSION: "v",
  HEADER: "h",
  PROMO: "pr",
  OFFICIAL: "oc",
  PASSWORD: "pw",
  KR_REWARDS: "kr",
  PROMOTED_SERVER: "pr",
  IS_DEDICATED: "ds",
  DONT_SEEK_MAPS: "dsma",
  DONT_SEEK_MODES: "dsmo"
};